import { createContext } from 'react';

import type { SessaoAtiva } from '@/features/autenticacao/sessaoEmMemoria';
import type { UsuarioAutenticado } from '@/types/api';

/**
 * Contexto da sessao.
 *
 * Fica num arquivo proprio, sem componente, porque o `react-refresh` reclama de
 * modulo que exporta componente e valor nao-componente junto — e porque separar
 * deixa o hook importavel sem arrastar o provedor.
 */
export interface Sessao {
  /** Sessao ativa, ou nulo quando ninguem esta autenticado. */
  sessao: SessaoAtiva | null;
  usuario: UsuarioAutenticado | null;
  autenticado: boolean;
  /**
   * Verdadeiro enquanto a aplicacao tenta restaurar a sessao do cookie.
   *
   * Quem decide navegacao precisa distinguir "nao autenticado" de "ainda nao sei":
   * tratar os dois igual manda para o login quem apenas recarregou a pagina com
   * sessao valida.
   */
  restaurando: boolean;
  /** Verdadeiro quando a senha foi definida por administrador e precisa trocar. */
  deveTrocarSenha: boolean;
  /** Autentica e guarda a sessao. Lanca ErroDeApi em falha. */
  entrar: (email: string, senha: string) => Promise<void>;
  /** Encerra a sessao no servidor e localmente. Nunca lanca. */
  sair: () => Promise<void>;
  /**
   * Verifica se o usuario tem a permissao.
   *
   * SERVE PARA DESENHAR A INTERFACE, NAO PARA PROTEGER. Esconder um botao nao
   * impede ninguem de chamar o endpoint; a decisao real e reavaliada no servidor
   * a cada requisicao. A comparacao e exata, como no servidor: `acao.aprovar` e
   * `ACAO.APROVAR` sao permissoes diferentes.
   */
  temPermissao: (codigo: string) => boolean;
}

export const SessaoContexto = createContext<Sessao | null>(null);
